import moment from 'moment';

const TS_FORMAT = 'MMM DD HH:mm';

// round off to nearest day or hour
export const getEndTime = (arg = 'day') => {
  if (arg === 'hour') {
    return moment().startOf('hour').format();
  }
  return moment().subtract(1, 'day').endOf('day').format();
};

export const getDisplayInterval = (duration) => {
  const to = moment(getEndTime('hour'));
  const from = moment(to).subtract(duration, 'days');

  return {
    from: from.format(TS_FORMAT),
    to: to.format(TS_FORMAT),
  };
};
